import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { Filter1TwoTone as F1, Filter2TwoTone as F2 } from '@mui/icons-material/'
import { Filter3TwoTone as F3, Filter4TwoTone as F4 } from '@mui/icons-material/'
import { Filter5TwoTone as F5, Filter6TwoTone as F6 } from '@mui/icons-material/'
import { Filter7TwoTone as F7, Filter8TwoTone as F8 } from '@mui/icons-material/'
import { saveTemporalFeatures } from '../../redux/slices/Tree/treeFeatures'
import { Tab, Tabs, Box, Grid } from '@mui/material'
import { TabPanel } from '../TabPanel'
import AutocompleteGroupConditionsGeneral from '../Autocomplete/InconvenienceGroups'
import ItemsContainer from '../ItemsContainer'
import LinearIndeterminate from '../LinearIndeterminate'
import * as service from '../../services'
import './tabsContainer.css'

const HEIGHT_BOX = 362
const KEY_ISNOT_CHIP = [1, 7]
const ICONS = [F1, F2, F3, F4, F5, F6, F7, F8]

const STYLE_TABS = {
  orientation: 'vertical',
  variant: 'scrollable',
  'aria-label': 'vertical tabs',
  sx: { borderRight: 1, borderColor: 'divider', width: '190px' },
}

const STYLE_TAB = {
  fontSize: 12,
  color: '#0000008a',
  '&:hover': { color: 'var(--color-primary)' },
  selected: false,
}

const STYLE_BOX = {
  flexGrow: 1,
  bgcolor: 'background.paper',
  display: 'flex',
  height: HEIGHT_BOX,
}

function a11yProps(index) {
  return {
    id: `tab-incov-${index}`,
    'aria-controls': `tabpanel-inconvs-${index}`,
  }
}

const TabsContainer = ({ itemsfk, editable }) => {
  const dispatch = useDispatch()
  const [value, setValue] = React.useState(0)
  const [category, setCategory] = React.useState(null)
  const temporalFeature = useSelector(state => state.treeFeatures.temporal)

  const handleChange = (event, newValue) => setValue(newValue)

  const ElementsInside = ({ tabId }) => {
    const existItems = _.filter(temporalFeature, ['category', tabId])
    if (_.includes(KEY_ISNOT_CHIP, tabId))
      return existItems.map((obj, i) => (
        <ItemsContainer key={`frmk-tab-${i}`} {...obj} editable={editable} />
      ))
    return (
      <AutocompleteGroupConditionsGeneral
        data={existItems}
        idcategory={tabId}
        editable={editable}
      />
    )
  }

  React.useEffect(() => {
    dispatch(saveTemporalFeatures(itemsfk))
    service
      .getCategoryAll()
      .then(response => setCategory(response))
      .catch(err => console.log('Error :>> ', err.message))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!temporalFeature?.length || !Boolean(category)) return <LinearIndeterminate />

  return (
    <Box sx={STYLE_BOX}>
      <Tabs value={value} onChange={handleChange} {...STYLE_TABS}>
        {category.map((valueCategory, index) => {
          const Icon = ICONS[index]
          return (
            <Tab
              key={`tab-${index}`}
              sx={STYLE_TAB}
              label={valueCategory}
              {...a11yProps(index)}
              icon={<Icon />}
            />
          )
        })}
      </Tabs>
      {category.map((valueCategory, index) => (
        <TabPanel key={`TabPl-${index + 1}`} value={value} index={index}>
          <Grid container spacing={2}>
            <ElementsInside tabId={index + 1} />
          </Grid>
        </TabPanel>
      ))}
    </Box>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

export default TabsContainer
